import React from 'react';
import { DeliveryTypes } from '~/features/checkout/models/checkout';
import { DeliveryContentClickAndCollect } from '../DeliveryAddressOption/components/DeliveryContent/DeliveryContentClickAndCollect';
import { useCheckout } from '../../hooks/useCheckout';
import { DeliveryContentDroppoint } from '../DeliveryAddressOption/components/DeliveryContent/DeliveryContentDroppoint';
import { DeliveryContentAddress } from '../DeliveryAddressOption/components/DeliveryContent/DeliveryContentAddress';
import { useCheckoutState } from '../../hooks/useCheckoutState';
import type { Store } from '~/lib/data-contract/salesforce';

type Props = {
    chosenShippingMethod: DeliveryTypes;
    handleCloseDrawer: () => void;
    showStepDrawer: boolean;
    onClickAndCollectStoreSelectRequest: (store: Store) => boolean;
};

export const DeliveryStepResolver = ({
    chosenShippingMethod,
    handleCloseDrawer,
    showStepDrawer,
    onClickAndCollectStoreSelectRequest,
}: Props) => {
    const { carriers, setCarrier, mapMarkers } = useCheckout();

    const { carrier } = useCheckoutState();

    switch (chosenShippingMethod) {
        case DeliveryTypes.clickAndCollect:
            return (
                <DeliveryContentClickAndCollect
                    handleCloseDrawer={handleCloseDrawer}
                    showStepDrawer={showStepDrawer}
                    onClickAndCollectStoreSelectRequest={onClickAndCollectStoreSelectRequest}
                />
            );

        case DeliveryTypes.dropPoint:
            return (
                <DeliveryContentDroppoint
                    handleCloseDrawer={handleCloseDrawer}
                    selectedCarrier={carrier?.dropPoint}
                    optionList={carriers?.dropPoint}
                    mapMarkers={mapMarkers}
                    setCarrier={setCarrier}
                />
            );

        case DeliveryTypes.addressDelivery:
            return (
                <DeliveryContentAddress
                    handleCloseDrawer={handleCloseDrawer}
                    selectedCarrier={carrier?.addressDelivery}
                    optionList={carriers?.addressDelivery}
                    setCarrier={setCarrier}
                />
            );

        default:
            return null;
    }
};
